import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Card, CardContent, Typography, Grid, Button, Collapse, List, ListItem,
  Link, FormControl, InputLabel, Select, MenuItem, Stack, Chip, Paper } from '@mui/material';
import { WorkOutline, ExpandMore, ExpandLess, Email, Description } from '@mui/icons-material';
import { downloadResumeFile } from '../../../helper/organizationsApis';
import { OrganizationHiretechcopmany } from "../../../helper/base_url";

const HiretechHiredUsers = () => {
  const [companyData, setCompanyData] = useState(null);
  const [error, setError] = useState('');
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [selectedOpportunityType, setSelectedOpportunityType] = useState('Internship');

  useEffect(() => {
    const fetchHiringPosts = async () => {
      try {
        const token = localStorage.getItem('company_token');
        const response = await axios.get(`${OrganizationHiretechcopmany}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        //console.log(response.data.data)
        setCompanyData(response.data.data);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to fetch data');
      }
    };

    fetchHiringPosts();
  }, []);

  const toggleExpand = (index) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const opportunityTypes = ['Internship', 'Full-time Job'];

  if (error) return <Typography color="error" align="center" mt={4}>{error}</Typography>;
  if (!companyData) return <Typography align="center" mt={4}>Loading...</Typography>;

  if (!companyData.hirings || companyData.hirings.length === 0)
  return (
    <Box textAlign="center" py={10}>
      <Typography variant="h6" color="text.secondary">
        No hiring opportunities available yet.
      </Typography>
    </Box>
  );

  return (
   <Box
      sx={{
        inlineSize: '100%',
        backgroundColor: '#f4f6f8',
        padding: '80px 20px 20px 20px',
        blockSize: '100%',
        overflowY: 'auto',
        position: 'relative',
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="start"
        justifyContent="start"
        mb={4}
      >
        <WorkOutline color="primary" sx={{ fontSize: 40 }} />
        <Typography variant="h6" fontWeight={600} color="primary">
          Hired Users
        </Typography>
      </Stack>
      <Box
        mb={4}
        maxWidth={320}
        mx="auto"
        ml={2}
        alignItems="start"
        justifyContent="start"
      >
        <FormControl fullWidth size="medium" variant="outlined">
          <InputLabel id="opportunity-type-label">Opportunity Type</InputLabel>
          <Select
            labelId="opportunity-type-label"
            value={selectedOpportunityType}
            label="Opportunity Type"
            onChange={(e) => setSelectedOpportunityType(e.target.value)}
          >
            {opportunityTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Grid container spacing={5}>
        {companyData.hirings
          .filter(
            (hiring) =>
              selectedOpportunityType === '' ||
              hiring.opportunityOverview?.opportunityType === selectedOpportunityType
          )
          .map((hiring, index) => {
            const hiredUsers = hiring.appliedUsers?.filter((user) => user.isHired) || [];

            return (
              <Grid item xs={12} md={6} key={index}>
                <Card
                  elevation={8}
                  sx={{
                    borderRadius: 4,
                    overflow: 'visible',
                    position: 'relative',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
                    transition: 'transform 0.3s ease',
                    '&:hover': { transform: 'translateY(-6px)' },
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="body"
                      fontWeight={600}
                      gutterBottom
                      color="text.primary"
                      sx={{ letterSpacing: 0.5 }}
                    >
                      {hiring.opportunityOverview?.title || 'N/A'}
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={() => toggleExpand(index)}
                      endIcon={expandedIndex === index ? <ExpandLess /> : <ExpandMore />}
                      sx={{
                        textTransform: 'none',
                        fontWeight: 'bold',
                        fontSize: 16,
                        py: 1,
                        marginTop :"20px",
                        borderRadius: 3,
                        boxShadow: '0 4px 10px rgba(25, 118, 210, 0.4)',
                        transition: 'background-color 0.3s ease',
                        '&:hover': { backgroundColor: '#1058d1' },
                      }}
                    >
                      Show Hired Users ({hiredUsers.length})
                    </Button>
                    <Collapse in={expandedIndex === index} timeout="auto" unmountOnExit>
                      <Paper
                        elevation={3}
                        sx={{
                          mt: 3,
                          maxHeight : 350,
                          overflowY: 'auto',
                          borderRadius: 3,
                          bgcolor: '#e3f2fd',
                          px: 2,
                          py: 2,
                        }}
                      >
                        {hiredUsers.length > 0 ? (
                          <List dense disablePadding>
                            {hiredUsers.map((user, idx) => (
                              <Box key={user._id || idx} sx={{ mb: 1 }}>
                                {/* Avatar Placeholder */}
                                    {/* <Avatar sx={{ bgcolor: '#1976d2' }}>
                                      {user.name?.[0] || 'U'}
                                    </Avatar> */}
                                <ListItem
                                  alignItems="flex-start"
                                  sx={{
                                    bgcolor: '#fff',
                                    borderRadius: 3,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    px: 3,
                                    py: 2,
                                    mb: 1,
                                    transition: 'background-color 0.3s ease',
                                    '&:hover': {
                                      // bgcolor: '#bbdefb',
                                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                    },
                                  }}
                                >
                                  <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" width="100%">
                                    <Box flexGrow={1} minWidth={0}>
                                      <Typography
                                        variant="subtitle1"
                                        fontWeight={700}
                                        color="primary"
                                        noWrap
                                        title={user.name}
                                      >
                                        {idx + 1}. {user.name || 'N/A'}
                                      </Typography>
                                      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" mt={0.5}>
                                        <Email fontSize="small" color="action" />
                                        <Typography variant="body2" color="text.secondary" noWrap>
                                          {user.email || 'No Email'}
                                        </Typography>
                                      </Stack>
                                      <Typography variant="body2" color="text.secondary" mt={0.5}>
                                        <strong>Applied Date:</strong>{' '}
                                        {user.appliedDate ? new Date(user.appliedDate).toLocaleString() : 'N/A'}
                                      </Typography>
                                      {user.resume && (
                                        <Stack direction="row" spacing={1} alignItems="center" mt={0.5}>
                                          <Description fontSize="small" color="action" />
                                          <Link
                                            component="button"
                                            underline="hover"
                                            sx={{ fontWeight: 600 }}
                                            onClick={() => downloadResumeFile(user.email, user.resume)}
                                          >
                                            Download Resume
                                          </Link>
                                        </Stack>
                                      )}
                                      {/* <Typography variant="body2" mt={0.5}>
                                        <strong>Status:</strong> {user.statusofStudent || 'N/A'}
                                      </Typography> */}
                                    </Box>
                                    <Chip
                                      label="Hired"
                                      color="success"
                                      variant="filled"
                                      sx={{
                                        fontWeight: 700,
                                        height : 28,
                                        alignSelf: 'center',
                                      }}
                                    />
                                  </Stack>
                                </ListItem>
                              </Box>
                            ))}
                          </List>
                        ) : (
                          <Typography variant="body2" color="text.secondary" textAlign="center" py={4}>
                            No hired users yet.
                          </Typography>
                        )}
                      </Paper>
                    </Collapse>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
};

export default HiretechHiredUsers;
